import React from "react";
import { Facebook, Youtube, Mail, Phone } from "lucide-react";

export const Footer = ({ onOpenContacts }) => {
  return (
    <footer
      className="relative w-full px-6 md:px-12 lg:px-20 py-16 border-t border-white/10 bg-[#050505]"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12 items-start">
          <div className="min-w-0">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_charge-charlie-band/artifacts/hoz25lwc_Charge%20Charlie%20Cover%20Band.webp"
                alt="CHARGE Charlie Cover Band logo"
                className="h-16 w-16 md:h-20 md:w-20 object-contain drop-shadow-[0_0_10px_rgba(0,229,255,0.4)] flex-shrink-0"
              />
              <span className="font-display text-2xl md:text-3xl font-bold tracking-[0.15em] uppercase text-white leading-none truncate">
                CHARGE
              </span>
            </div>
            <h3 className="font-display text-base font-medium text-white/70 tracking-tight">
              Charlie Cover Band
            </h3>
            <p className="font-body text-sm text-white/50 mt-3 max-w-xs">
              Élő rock energia — minden koncerten.
            </p>
          </div>

          <div>
            <p className="font-display text-xs tracking-[0.3em] uppercase text-white/40 mb-4">
              Navigáció
            </p>
            <ul className="space-y-2 font-body text-white/70 text-sm">
              <li><a href="#bio" className="hover:text-[#00E5FF] transition-colors">Bemutatkozás</a></li>
              <li><a href="#tagok" className="hover:text-[#00E5FF] transition-colors">Tagok</a></li>
              <li><a href="#archivum" className="hover:text-[#00E5FF] transition-colors">Archívum</a></li>
              <li><a href="#kepek" className="hover:text-[#00E5FF] transition-colors">Képek</a></li>
              <li><a href="#video" className="hover:text-[#00E5FF] transition-colors">Bemutató videó</a></li>
            </ul>
          </div>

          <div>
            <p className="font-display text-xs tracking-[0.3em] uppercase text-white/40 mb-4">
              Gyors elérés
            </p>
            <div className="flex gap-3 mb-6">
              <a
                href="https://www.facebook.com/Charge.zenekar/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="flex h-10 w-10 items-center justify-center border border-white/15 text-white/70 hover:border-[#00E5FF] hover:text-[#00E5FF] transition-colors"
                data-testid="footer-facebook"
              >
                <Facebook className="h-4 w-4" />
              </a>
              <a
                href="https://www.youtube.com/@charge4797"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="flex h-10 w-10 items-center justify-center border border-white/15 text-white/70 hover:border-[#FF007F] hover:text-[#FF007F] transition-colors"
                data-testid="footer-youtube"
              >
                <Youtube className="h-4 w-4" />
              </a>
              <a
                href="mailto:simkojana@gmail.com"
                aria-label="Email"
                className="flex h-10 w-10 items-center justify-center border border-white/15 text-white/70 hover:border-[#7000FF] hover:text-[#7000FF] transition-colors"
                data-testid="footer-email"
              >
                <Mail className="h-4 w-4" />
              </a>
              <a
                href="tel:+36705336029"
                aria-label="Telefon"
                className="flex h-10 w-10 items-center justify-center border border-white/15 text-white/70 hover:border-[#00E5FF] hover:text-[#00E5FF] transition-colors"
                data-testid="footer-phone"
              >
                <Phone className="h-4 w-4" />
              </a>
            </div>
            <button
              onClick={onOpenContacts}
              data-testid="footer-contacts-button"
              className="inline-flex items-center gap-2 bg-transparent border border-[#00E5FF] text-[#00E5FF] hover:bg-[#00E5FF] hover:text-black transition-all duration-300 px-5 py-2.5 uppercase tracking-[0.25em] text-[0.65rem] font-bold"
            >
              Elérhetőségek
            </button>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="font-body text-xs text-white/30">
            © {new Date().getFullYear()} CHARGE Charlie Cover Band. Minden jog fenntartva.
          </p>
          <p className="font-display text-[0.65rem] uppercase tracking-[0.3em] text-white/30">
            A zene gyógyít
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
